var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.mode == "edit"
      ? _c(
          "div",
          [
            _c(
              "el-radio",
              {
                attrs: { label: true },
                model: {
                  value: _vm.localValue.boolValue,
                  callback: function($$v) {
                    _vm.$set(_vm.localValue, "boolValue", $$v)
                  },
                  expression: "localValue.boolValue"
                }
              },
              [_vm._v(_vm._s(_vm.$l10n.__("Oui")))]
            ),
            _vm._v(" "),
            _c(
              "el-radio",
              {
                attrs: { label: false },
                model: {
                  value: _vm.localValue.boolValue,
                  callback: function($$v) {
                    _vm.$set(_vm.localValue, "boolValue", $$v)
                  },
                  expression: "localValue.boolValue"
                }
              },
              [_vm._v(_vm._s(_vm.$l10n.__("Non")))]
            )
          ],
          1
        )
      : _c("p", [_vm._v("\n        " + _vm._s(_vm.localValueLabel) + "\n    ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }